import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { compose } from "redux";
import OfferList from "./OfferList";
import OfferForm from "./OfferForm";

import { ADD_NEW } from "constants/commonConstants";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import offerReducer from "store/OfferDetail/reducer";
import offerSaga from "store/OfferDetail/saga";
import productDetailReducer from "store/ProductDetail/reducer";
import productDetailSaga from "store/ProductDetail/saga";

const offerKey = "OfferDetail";
const productDetailKey = "ProductDetail";

const withOfferReducer = injectReducer({
  key: offerKey,
  reducer: offerReducer,
});
const withOfferSaga = injectSaga({ key: offerKey, saga: offerSaga });

const withProductDetailReducer = injectReducer({
  key: productDetailKey,
  reducer: productDetailReducer,
});
const withProductDetailSaga = injectSaga({
  key: productDetailKey,
  saga: productDetailSaga,
});

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDialog: false,
      offerData: null,
    };

    this.validator = new SimpleReactValidator();
  }

  onOfferInsertUpdateSuccess = () => {
    this.setState({
      formDialog: false,
      offerData: null,
    });
  };

  viewOffer = (offer) => {
    this.setState({
      formDialog: true,
      offerData: offer,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <OfferForm
            formDialog={this.state.formDialog}
            offerRecord={this.state.offerData}
            closeModal={() => this.onOfferInsertUpdateSuccess()}
          ></OfferForm>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between">
                    <h4 className="mt-0 page-title">Offer</h4>
                    <button
                      className="btn btn-primary waves-effect waves-light float-right"
                      onClick={() => this.viewOffer(null)}
                    >
                      {ADD_NEW}
                    </button>
                  </div>

                  <OfferList
                    onViewOffer={(offerValues) => this.viewOffer(offerValues)}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default compose(
  withOfferReducer,
  withOfferSaga,
  withProductDetailReducer,
  withProductDetailSaga,
  withRouter
)(Index);
//export default withRouter(withConnect)(Index);
